module.exports = __webpack_public_path__ + "static/media/DM168-ray-reits-image-adobe-stock.dbb21baa.jpeg";